import { Component } from '@angular/core';

import { MomentModule } from 'ngx-moment';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { LineBreaksPipe } from '../../pipes';
import { ShipmentActivitiesListItemComponent } from '../shipment-activities-list-item/shipment-activities-list-item.component';

@Component({
    standalone: true,
    imports: [LineBreaksPipe, MomentModule, TooltipModule, FontAwesomeModule, TranslateModule],
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'li[qwyk-shipment-activities-comment]',
    templateUrl: './shipment-activities-comment.component.html',
    styleUrls: ['./shipment-activities-comment.component.scss'],
})
export class ShipmentActivitiesCommentComponent extends ShipmentActivitiesListItemComponent {}
